var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
__name(_extends, "_extends");
import React from "react";
import Icon from "@ant-design/icons";
var InstagramSvg = /* @__PURE__ */ __name(function InstagramSvg2() {
  return /* @__PURE__ */ React.createElement("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "32",
    viewBox: "0 0 32 32"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M21.6 30.444h-11.2c-4.883-0.005-8.839-3.962-8.844-8.844v-11.2c0.005-4.883 3.962-8.839 8.844-8.844h11.2c4.883 0.005 8.839 3.962 8.844 8.844v11.201c-0.005 4.883-3.962 8.839-8.844 8.844h-0zM10.4 3.72c-3.677 0.013-6.654 2.99-6.667 6.665v11.215c0.013 3.677 2.99 6.654 6.665 6.667h11.201c3.677-0.013 6.654-2.99 6.667-6.665v-11.201c-0.013-3.677-2.99-6.654-6.665-6.667h-11.201z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M16 23.307c-4.035 0-7.307-3.271-7.307-7.307s3.271-7.307 7.307-7.307c4.035 0 7.307 3.271 7.307 7.307v0c-0.005 4.033-3.273 7.302-7.306 7.307h-0.001zM16 10.907c-2.813 0-5.093 2.28-5.093 5.093s2.28 5.093 5.093 5.093c2.813 0 5.093-2.28 5.093-5.093v0c-0.003-2.812-2.281-5.091-5.093-5.093h-0z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M26.004 7.898c0 1.051-0.852 1.902-1.902 1.902s-1.902-0.852-1.902-1.902c0-1.051 0.852-1.902 1.902-1.902s1.902 0.852 1.902 1.902z"
  }));
}, "InstagramSvg");
var InstagramIcon = /* @__PURE__ */ __name(function InstagramIcon2(props) {
  return /* @__PURE__ */ React.createElement(Icon, _extends({
    component: InstagramSvg
  }, props));
}, "InstagramIcon");
export {
  InstagramIcon
};
